import { render, staticRenderFns } from "./BlogDetails.vue?vue&type=template&id=46b7cd0e&scoped=true"
import script from "./BlogDetails.vue?vue&type=script&lang=js"
export * from "./BlogDetails.vue?vue&type=script&lang=js"
import style0 from "./BlogDetails.vue?vue&type=style&index=0&id=46b7cd0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b7cd0e",
  null
  
)

export default component.exports